import { Button, ButtonProps } from "@mui/material"
import PlayCircleOutlineSharpIcon from "@mui/icons-material/PlayCircleOutlineSharp"
import { useGetGraphDataQuery } from "@store/services/graphsService"
import { skipToken } from "@reduxjs/toolkit/query"
import { RunModelDto } from "@store/services/modelsService"
import { useAtomValue } from "jotai"
import { permissionsAtom } from "@store/authAtoms"
import { getEligibleSupportContractOptions } from "@features/run/RunModelForm/helpers"

type RunModelButtonProps = ButtonProps & {
  model: RunModelDto | undefined
}

const RunModelButton = ({ model, sx, ...props }: RunModelButtonProps) => {
  const { isFetching, isError } = useGetGraphDataQuery(model?.graph_key ?? skipToken)
  const permissions = useAtomValue(permissionsAtom)
  const fetchingGraphDataFailed = !isFetching && isError

  return (
    <Button
      variant="contained"
      color={"error"}
      disabled={
        isFetching ||
        !model ||
        fetchingGraphDataFailed ||
        getEligibleSupportContractOptions(model.family_key, permissions).length == 0
      }
      size={"medium"}
      sx={{ m: 1, ...sx }}
      startIcon={<PlayCircleOutlineSharpIcon />}
      {...props}
    >
      Sample this model
    </Button>
  )
}

export default RunModelButton
